import * as jsforce from 'jsforce'
import type { PRAIPrompt, AIGenerateRequest, AIGenerateResponse } from '../../types/salesforce'
import { SOBJECT_NAMES } from '../../constants/salesforce'

/**
 * PROMPT-0006プロンプトを取得
 */
export async function getDefaultAIPrompt(conn: jsforce.Connection): Promise<PRAIPrompt | null> {
  const result = await conn.query<PRAIPrompt>(`
    SELECT Id, Name, PromptName__c, Description__c
    FROM ${SOBJECT_NAMES.AI_PROMPT}
    WHERE Name = 'PROMPT-0006'
    LIMIT 1
  `)

  if (!result.records || result.records.length === 0) {
    return null
  }

  return result.records[0]
}

/**
 * AI生成実行
 */
export async function generateAIContent(
  conn: jsforce.Connection,
  request: AIGenerateRequest,
): Promise<AIGenerateResponse> {
  try {
    // REST API経由でApex Classを呼び出し (@RestResource + @HttpPost)
    const result = await conn.apex.post('/PRSheetAIService', request)

    return result as AIGenerateResponse
  } catch (error) {
    console.error('AI generation error:', error)
    throw new Error(`AI生成に失敗しました: ${error}`)
  }
}

/**
 * AI生成を確定 (Applied状態に変更)
 */
export async function applyAIGeneration(conn: jsforce.Connection, generationId: string): Promise<void> {
  try {
    const res = (await conn.apex.patch(`/PRSheetAIService?generationId=${encodeURIComponent(generationId)}`, {})) as {
      success: boolean
    }
    if (!res.success) {
      throw new Error('AI生成の確定に失敗しました')
    }
  } catch (error) {
    console.error('Apply generation error:', error)
    throw new Error(`AI生成の確定に失敗しました: ${error}`)
  }
}

/**
 * AI生成を破棄 (Discarded状態に変更)
 */
export async function discardAIGeneration(conn: jsforce.Connection, generationId: string): Promise<void> {
  try {
    await conn.apex.delete(`/PRSheetAIService?generationId=${encodeURIComponent(generationId)}`)
  } catch (error) {
    console.error('Discard generation error:', error)
    throw new Error(`AI生成の破棄に失敗しました: ${error}`)
  }
}
